module.exports = __webpack_public_path__ + "img/logo_colegio_sao_jose.33e3636f.png";